import { createFileRoute } from "@tanstack/react-router";

import { ReferralProgram } from "~/components/referral-program";
import { PageHeader } from "~/components/ui/page-title";
import { getOnboardingStatus } from "~/lib/functions/coach-onboarding";

export const Route = createFileRoute("/_user/my-coaching/referrals")({
  staticData: { title: "Referrals" },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["coach", "onboarding-status"],
      queryFn: () => getOnboardingStatus(),
    });
    return {};
  },
  component: ReferralsPage,
});

/**
 * The page owns only its identity (the `Referrals` h1, matching the route
 * title). The $50 promise deliberately lives INSIDE `ReferralProgram` — one
 * copy, one source, so the heading and the card can never drift apart.
 */
function ReferralsPage() {
  return (
    <div className="max-w-4xl space-y-8">
      <PageHeader title="Referrals" />
      <ReferralProgram />
    </div>
  );
}
